export const ROLES = [
    "Owner",
    "President, Baseball Operations",
    "General Manager",
    "Assistant GM",
    "Field Manager",
    "Scouting Director",
    "Shareholder",
    "Fan"
];